import { css } from "@emotion/react"
import { BREAKPOINTS } from "source/shared/hooks/useWindowDimensions"

const BORDER_COLOR = "var(--color-tint5)"

interface PaneGroupProps {
  children: React.ReactNode
}

export function PaneGroup({ children }: PaneGroupProps) {
  return (
    <div
      className="d-f jc-sb g-3 g-6@lg"
      css={css`
        @media (min-width: ${BREAKPOINTS.MD}px) {
          border: 1px solid ${BORDER_COLOR};
          border-radius: 0.5rem;
          padding: 1.5rem;
        }
      `}
    >
      {children}
    </div>
  )
}
